const hidePanel = function(targetPanel) {
  targetPanel.setAttribute('aria-hidden', true);
  targetPanel.classList.add('is-hidden');
  targetPanel.setAttribute('tabindex', -1);
};

const deactivateTrigger = function(targetTrigger) {
  targetTrigger.classList.remove('is-expanded');
  targetTrigger.setAttribute('aria-expanded', false);
};

const showPanel = function(trigger, targetPanel) {
  trigger.classList.add('is-expanded');
  trigger.setAttribute('aria-expanded', true);
  targetPanel.setAttribute('aria-hidden', false);
  targetPanel.classList.remove('is-hidden');
  targetPanel.setAttribute('tabindex', 0);
  window.history.pushState(
    null,
    null,
    trigger.getAttribute('data-target-panel'),
  );
};

const hideOthers = function(target) {
  const activeTargetIndex = target.index;

  for (let i = target.triggersNodelist.length - 1; i >= 0; i -= 1) {
    if (i !== activeTargetIndex) {
      deactivateTrigger(target.triggersNodelist[i]);
    }
  }

  for (let j = target.panelsNodelist.length - 1; j >= 0; j -= 1) {
    if (j !== activeTargetIndex) {
      hidePanel(target.panelsNodelist[j]);
    }
  }
};

const findCorrectClickTarget = function(element, cls) {
  let el = element;

  while (!el.classList.contains(cls)) {
    el = el.parentElement;
  }

  return el;
};

const clickEvent = function(e) {
  e.preventDefault();

  const trigger = findCorrectClickTarget(e.target, 'js-tab-trigger');
  const targetPanel = document.querySelector(trigger.dataset.targetPanel);

  if (!trigger.classList.contains('is-expanded')) {
    showPanel(trigger, targetPanel);
    hideOthers(trigger);
  }
};

const tabs = function() {
  const tabsGroups = document.querySelectorAll('.js-tabs-group');

  if (tabsGroups === null || tabsGroups.length === 0) {
    return;
  }

  for (let i = tabsGroups.length - 1; i >= 0; i -= 1) {
    const tabTriggers = tabsGroups[i].querySelectorAll('.js-tab-trigger');
    const tabPanels = tabsGroups[i].querySelectorAll('.js-tab-panel');

    for (let j = tabTriggers.length - 1; j >= 0; j -= 1) {
      tabTriggers[j].index = j;
      tabTriggers[j].triggersNodelist = tabTriggers;
      tabTriggers[j].panelsNodelist = tabPanels;
      tabTriggers[j].addEventListener('click', clickEvent, false);
    }

    for (let k = tabPanels.length - 1; k >= 0; k -= 1) {
      if (tabPanels[k].querySelector('.js-scroll-panel') !== null) {
        tabPanels[k].scrollPanel = tabPanels[k].querySelector(
          '.js-scroll-panel',
        );
      }
    }
  }

  if (window.location.hash.length > 0) {
    const hashedElement = document.querySelector(
      `[data-target-panel="${window.location.hash}"]`,
    );
    if (hashedElement !== undefined) {
      hashedElement.click();
    }

    const pagingLinks = document.querySelectorAll('.c-paging-link[href]');
    if (pagingLinks !== undefined) {
      for (let i = pagingLinks.length - 1; i >= 0; i -= 1) {
        pagingLinks[i].href += window.location.hash;
      }
    }
  }
};

export default tabs;



// WEBPACK FOOTER //
// ./src/scripts/modules/tabs.js